import { Empty, Typography } from "antd";
import React from "react";
import ReactHTMLParser from "react-html-parser";
import { InteractionNotificationPreview } from "../helpers/shared-interfaces";
import { formatter } from "../helpers/utilities";
import ModalCreator from "./ModalCreator";

const { Text, Title } = Typography;

interface Props {
  showModal: boolean;
  chequeNumber: string;
  chequeAmount: number;
  preview?: InteractionNotificationPreview | null;
  isLoading: boolean;
  isSending: boolean;
  onSend: () => void;
  onClose: () => void;
}

export default function ReturnedChequeNotificationModal(
  props: Props,
): JSX.Element {
  const { preview } = props;

  return ModalCreator({
    title: "Notify Returned Cheque",
    okType: "primary",
    okText: "Send",
    showModal: props.showModal,
    isLoading: props.isLoading || props.isSending,
    onOkay: props.onSend,
    toggleModal: props.onClose,
    okayButtonProps: {
      disabled: !preview || props.isLoading || props.isSending,
    },
    width: 760,
    inscription: (
      <div style={{ display: "grid", gap: 16 }}>
        <div>
          <Text strong>Cheque Number</Text>
          <div style={{ marginTop: 8 }}>
            <Text>{props.chequeNumber}</Text>
          </div>
        </div>

        <div>
          <Text strong>Cheque Amount</Text>
          <div style={{ marginTop: 8 }}>
            <Text>{formatter.format(props.chequeAmount)}</Text>
          </div>
        </div>

        {!preview && (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              props.isLoading
                ? "Loading the notification preview..."
                : "Unable to load the notification preview."
            }
          />
        )}

        {preview && (
          <div style={{ display: "grid", gap: 12 }}>
            <div style={{ display: "grid", gap: 4 }}>
              <Text strong>Recipient</Text>
              <Text>{preview.recipient}</Text>
            </div>
            {preview.ccRecipients && preview.ccRecipients.length > 0 && (
              <div style={{ display: "grid", gap: 4 }}>
                <Text strong>CC</Text>
                <Text>{preview.ccRecipients.join(", ")}</Text>
              </div>
            )}
            {preview.subject && (
              <div style={{ display: "grid", gap: 4 }}>
                <Text strong>Subject</Text>
                <Text>{preview.subject}</Text>
              </div>
            )}
            <div style={{ display: "grid", gap: 8 }}>
              <Title level={5} style={{ margin: 0 }}>
                Preview
              </Title>
              <div
                style={{
                  border: "1px solid #f0f0f0",
                  borderRadius: 6,
                  padding: 16,
                  background: "#fafafa",
                  whiteSpace: "pre-wrap",
                }}
              >
                {ReactHTMLParser(preview.body)}
              </div>
            </div>
          </div>
        )}
      </div>
    ),
  });
}
